var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [
        _vm._v(" Upload Your Logo & Other Featured Images ")
      ]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _vm._v(
                        " Browse to select your Logo, and/or any other images that you wish to feature on your website. If you don't have a Logo or other images right now, click "
                      ),
                      _c("i", [_vm._v("Next Step")]),
                      _vm._v(". ")
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("v-file-input", {
                    attrs: {
                      "show-size": "",
                      accept: _vm.allowed_files,
                      outlined: "",
                      placeholder: "Select an image for your logo",
                      hint:
                        "Preferred sizes: Vertical: 160px * 160px Horizontal: 350px * 75px",
                      "persistent-hint": "",
                      "small-chips": "",
                      dense: "",
                      "prepend-icon": "mdi-paperclip",
                      loading: _vm.loadingLogo,
                      disabled: !!_vm.logoFile
                    },
                    on: {
                      change: _vm.uploadLogo
                    },
                    model: {
                      value: _vm.file,
                      callback: function callback($$v) {
                        _vm.file = $$v
                      },
                      expression: "file"
                    }
                  })
                ],
                1
              ),
              _vm.logoFile
                ? _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "v-chip-group",
                        [
                          _c(
                            "v-chip",
                            {
                              attrs: {
                                close: ""
                              },
                              on: {
                                "click:close": _vm.removeFile
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.file.name) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("v-file-input", {
                    attrs: {
                      multiple: "",
                      clearable: false,
                      "show-size": "",
                      accept: _vm.allowed_files,
                      outlined: "",
                      placeholder: "Select Other Images",
                      hint: "You can upload up to ".concat(
                        _vm.maxImgsCount,
                        " images"
                      ),
                      "persistent-hint": "",
                      "small-chips": "",
                      dense: "",
                      "prepend-icon": "mdi-paperclip",
                      disabled: _vm.otherDisabled,
                      loading: _vm.loadingOther
                    },
                    on: {
                      change: _vm.uploadOther
                    },
                    model: {
                      value: _vm.otherImages,
                      callback: function callback($$v) {
                        _vm.otherImages = $$v
                      },
                      expression: "otherImages"
                    }
                  })
                ],
                1
              ),
              _vm.otherImgs.length
                ? _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "v-chip-group",
                        _vm._l(_vm.otherImgs, function(file, i) {
                          return _c(
                            "v-chip",
                            {
                              key: "o-img-".concat(i),
                              attrs: {
                                close: ""
                              },
                              on: {
                                "click:close": function clickClose($event) {
                                  return _vm.removeOther(file)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(file.name) + " ")]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }